import { Controller } from "@hotwired/stimulus"
import * as echarts from "echarts"

export default class extends Controller {
  static targets = ["canvas"]
  static values = { data: Object, title: String, radius: String }

  connect() {
    this.chart = echarts.init(this.canvasTarget)
    this.resizeHandler = () => this.chart.resize()
    window.addEventListener("resize", this.resizeHandler)
    this.render()
  }

  render() {
    const [series] = this.dataValue.series
    const radius = this.radiusValue ? [`${this.radiusValue}%`, "70%"] : "70%"

    this.chart.setOption({
      ...(this.titleValue ? { title: { text: this.titleValue, backgroundColor: 'white', textStyle: { color: 'black' } } } : {}),
      tooltip: { trigger: "item" },
      legend: { bottom: 0, type: "scroll" },
      toolbox: { feature: { saveAsImage: { name: this.titleValue || "pie-chart" } } },
      series: {
        ...series,
        radius,
        label: {
          show: false
        }
      }
    })
  }

  disconnect() {
    window.removeEventListener("resize", this.resizeHandler)
    if (this.chart) { this.chart.dispose(); this.chart = null }
  }
}
